import { useState, useEffect } from "react";
import Icons from "../icons";
import { faRemove, faUpload, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import "./style.css";
import { uploadImage, getFileUrl } from "../../api/image";
import "../../utils/tailwind.css";

const ImageUploader = ({ onChange, imageUrl, title = "Image", imgStyle = {}, rootStyle = {} }) => {
  const [media, setMedia] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      if (imageUrl) {
        try {
          const { data: s3ImageUrl } = await getFileUrl({ file_url: imageUrl });
          setMedia(s3ImageUrl);

          const fileExtension = s3ImageUrl.split(".").pop().toLowerCase();

          if (["mp4", "webm", "ogg"].includes(fileExtension)) {
            setMediaType("video");
          } else if (true) {
            setMediaType("image");
          } else {
            setMediaType("other");
            setFileName(imageUrl.split("/").pop());
          }
        } catch (err) {
          console.error("Error loading image:", err);
        }
      } else {
        setMedia(null);
        setMediaType(null);
        setFileName(null);
      }
    };

    loadImage();
  }, [imageUrl]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setLoading(true);
      setFileName(file.name);

      try {
        if (onChange) {
          const res = await uploadImage({ file });
          onChange(res);
        }

        const fileType = file.type.split("/")[0];
        if (fileType === "image" || fileType === "video") {
          setMediaType(fileType);

          const reader = new FileReader();
          reader.onloadend = () => {
            setMedia(reader.result);
            setLoading(false);
          };
          reader.readAsDataURL(file);
        } else {
          setMediaType("other");
          setMedia(null);
          setLoading(false);
        }
      } catch (error) {
        console.error("Upload failed:", error);
        setLoading(false);
      }
    }
  };

  const handleRemoveFile = () => {
    setMedia(null);
    setMediaType(null);
    setFileName(null);
    if (onChange) onChange(null);
  };

  return (
    <div className="relative p-1 border border-gray-300 rounded-md" style={rootStyle}>
      {loading ? (
        <div className="text-center text-gray-500">Uploading...</div>
      ) : media ? (
        <div className="relative">
          {mediaType === "image" ? (
            <img src={media} alt="Uploaded" className="w-72 max-h-48 object-cover rounded-md" style={imgStyle} />
          ) : mediaType === "video" ? (
            <video src={media} controls className="w-72 rounded-md" />
          ) : (
            <div className="text-gray-700 flex items-center gap-2 bg-gray-100 p-2 rounded-md">
              <Icons iconName={faFileAlt} />
              <span>{fileName}</span>
            </div>
          )}
          <button
            className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center shadow-md hover:bg-red-700"
            onClick={handleRemoveFile}
          >
            <Icons iconName={faRemove} />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center cursor-pointer text-center border-dashed rounded-md p-2 hover:border-blue-500">
          <input type="file" accept="*/*" onChange={handleFileChange} className="hidden" />
          <div className="text-gray-600 flex items-center gap-2">
            Upload {title} <Icons iconName={faUpload} />
          </div>
        </label>
      )}
    </div>
  );
};

export default ImageUploader;
